// IMPORT
const THREE = require('three')
import {state as gameState} from '../main'
import {config as gameConfig} from '../config'
import sounds from '../sounds'
import {TweenMax, Cubic} from 'gsap'
import Runner from './runner'
import * as STAGES from '../stages'
import camera from '../camera'

class Player extends Runner {

  constructor (config) {
    super(Object.assign(config, {
      isPlayer: true,
      type: 'player'
    }))

    this.cameraAnchor = new THREE.Object3D()
    this.mesh.add(this.cameraAnchor)
    this.cameraAnchor.add(camera)
  }


  // **********************************************************************
  //
  // UPDATE
  //
  // **********************************************************************
  updateAnimation = (delta)=> {
    if (this.mixer) {
      this.mixer.timeScale = 1
      this.mixer.update(delta / 1000)
    }
  }

  updateState = ()=> {
    let vel = gameState.velocity.now
    this.state.distance = gameConfig.startDistance + (gameState.progress.percent * gameConfig.numLaps)
  }

  updatePosition () {

    const pt1 = this.state.path.getPointAt(this.state.distance % 1)
    this.mesh.position.set(pt1.x, pt1.y, pt1.z)

    const pt2 = this.state.path.getPointAt((this.state.distance + 0.014) % 1)
    this.mesh.lookAt(pt2)
  }

  // **********************************************************************
  //
  // METHODS
  //
  // **********************************************************************
  start = ()=> {
    // this.mesh.visible = true
    this.model.visible = false

    // this.model.children[0].add(this.cameraAnchor)
    // this.cameraAnchor.add(camera)
  }


}


export default Player



// WEBPACK FOOTER //
// ./src/components/game/runner/player.js